import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=67e10918&scoped=true&lang=pug&"
import script from "./Notices.vue?vue&type=script&lang=ts&"
export * from "./Notices.vue?vue&type=script&lang=ts&"
import style0 from "./Notices.vue?vue&type=style&index=0&id=67e10918&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e10918",
  null
  
)

export default component.exports